import "./loading.scss";

export const Loading = () => {
	return (
		<div className="loading-gif-wrapper">
			<img src="/images/loading.gif" className="loading-gif" />
		</div>
	);
};
